import { atom } from "jotai";

const userProjectsAtom = atom<any | string>("");
userProjectsAtom.debugLabel = "User Projects";

export { userProjectsAtom };
